import React, { useEffect, useMemo, useState } from "react";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";
import { Box } from "@mui/material";
import { forwardRef } from "react";
import { PARAMS_TO_PRESERVE } from "../helpers/constants";

const QueryPreservingLink = forwardRef(function QueryPreservingLink(
  { to, target, children, ...props },
  ref
) {
  const location = useLocation();
  const [queryParams, setQueryParams] = useState("");

  useEffect(() => {
    setQueryParams(location.search);
  }, [location, to]);

  const isExternalLink = useMemo(() => {
    return to?.includes("http") || to?.includes("https");
  }, [to]);

  const constructUrl = () => {
    const existingParams = new URLSearchParams(queryParams);

    existingParams.forEach((_value, key) => {
      if (!PARAMS_TO_PRESERVE.includes(key)) existingParams.delete(key);
    });

    // If URL already has params, merge them
    if (to.includes("?")) {
      const [path, newParams] = to.split("?");
      const newParamsObj = new URLSearchParams(newParams);

      // Merge params, with new ones taking precedence
      newParamsObj.forEach((value, key) => {
        existingParams.set(key, value);
      });

      return `${path}?${existingParams.toString()}`;
    }

    // If no params in target URL, just append existing ones
    return `${to}${to.endsWith("/") ? "" : "/"}?${existingParams.toString()}`;
  };

  return isExternalLink ? (
    <Box
      component="a"
      href={constructUrl()}
      target={target}
      {...props}
      ref={ref}
    >
      {children}
    </Box>
  ) : (
    <Box component={Link} to={constructUrl()} {...props} ref={ref}>
      {children}
    </Box>
  );
});

export default QueryPreservingLink;
